import React, { Component } from "react";

import { Router, Switch } from "react-router-dom";

import RootView from "./pages/RootView";
import * as allUrls from "./router/allUrls";
import history from "./router/history";
import CustomRoute from "./router/CustomRoute";
import { observer } from "mobx-react";

// 参考 http://react-china.org/t/webpack-bundle-loader-lazy-react-router/14464/2

const routes = Object.values(allUrls).map(item => item.options);

@observer
class App extends Component {
  render() {
    return (
      <Router history={history}>
        <RootView>
          <Switch>
            {/*<Redirect exact from="/" to="/product/favorate" />*/}
            {/*<Route exact path="/404" component={lazy(PageNotFound)} />*/}
            {routes.map((route, i) => (
              <CustomRoute key={i} {...route} />
            ))}
            {/*<Route path="/:any" component={lazy(PageNotFound)} />*/}
          </Switch>
        </RootView>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js